import { CancelButton, ConfirmButtonLogout } from 'components/button/button.styled'
import { useAuth } from 'hooks/admin/useAuth'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { ButtonContainer, Container, Message, Title, Wrapper } from './logout.styles'

export const Logout: React.FC = () => {
    const navigate = useNavigate()
    const { signOut } = useAuth()

    const handleConfirm = async () => {
        try {
            await signOut()
            navigate('/')
        } catch (error: any) {
            console.error('Logout failed:', error.message)
        }
    }

    const handleCancel = () => {
        navigate(-1)
    }

    return (
        <Container>
            <Wrapper>
                <Title>Figyelmeztetés</Title>
                <Message>Biztosan ki szeretne jelentkezni?</Message>
                <ButtonContainer>
                    <ConfirmButtonLogout label="Kijelentkezés" icon="pi pi-check" onClick={handleConfirm} />
                    <CancelButton label="Mégsem" icon="pi pi-times" onClick={handleCancel} />
                </ButtonContainer>
            </Wrapper>
        </Container>
    )
}
